const MODEL_PREFIX = {
  garniture: 'Garnitura',
  kreveti: 'Krevet',
  loze: 'Loža',
  stolice: 'Stolica',
};

export const CATEGORY_ORDER = ['garniture', 'stolice', 'loze', 'kreveti'];

/** Imena modela — dodeljuju se stabilno po productId (isti ID uvek isto ime). */
const CATALOG_MODEL_NAMES = `
Astra Stora Nexa Vora Luma Sora Tera Mora Zora Kora Nira Vela Sena Toma Rova Dena Lira Miraq Sova Tiva Rinaq Noma Vina Zenaq Lova Tora Sira Mela Nava Rexa Vira Zira Lenaq Tena Sela Mova Nexaq Rovaq Voraq Zova Liraq Tira Sona Mira Niraq Rina Vena Ziraq Lumaq Tova Sera Mena Noraq Rora Velaq Zoraq Lora
`
  .trim()
  .split(/\s+/)
  .filter(Boolean);

function catalogNameForProductId(productId) {
  if (CATALOG_MODEL_NAMES.length === 0) return productId;
  let h = 0;
  for (let i = 0; i < productId.length; i += 1) {
    h = (Math.imul(31, h) + productId.charCodeAt(i)) | 0;
  }
  const idx = Math.abs(h) % CATALOG_MODEL_NAMES.length;
  return CATALOG_MODEL_NAMES[idx];
}

function fileStem(name) {
  return name.replace(/\.[^/.]+$/, '');
}

/**
 * @param {Record<string, string[]>} manifest — iz /gallery/manifest.json
 * @param {string} categoryKey
 */
export function getGalleryProductsForCategory(manifest, categoryKey) {
  const files = manifest?.[categoryKey];
  if (!Array.isArray(files) || files.length === 0) return [];

  const prefix = MODEL_PREFIX[categoryKey] || 'Model';

  return files.map((file) => {
    const stem = fileStem(file);
    const id = `${categoryKey}-${stem}`;
    return {
      id,
      name: `${prefix} ${catalogNameForProductId(id)}`,
      image: `/gallery/${categoryKey}/${file}`,
      description:
        'Izaberite količinu. Izbor materijala i dimenzije nameštaja unesite u polju napomene pri kreiranju upita.',
    };
  });
}

export function getAllGalleryProducts(manifest) {
  return CATEGORY_ORDER.flatMap((key) => getGalleryProductsForCategory(manifest, key));
}
